__turbopack_context__.v({
  "paw": "CSnFTq_paw",
  "pawRow": "CSnFTq_pawRow",
});
